import styled from 'styled-components';

import {FormControl, FormHelperText, Input, Stack, useToast} from "@chakra-ui/react";
import {useEffect, useState} from "react";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import useFeedback from "../../../utils/use_feedback";
import FormContainer from "../../../components/form_container";
import {useSetPassword} from "../../../api/password";
import {useSaveClicked} from "../../../store";

const SwitchHeading = styled.div``;

const PasswordSettings = styled(({className}) => {

    const {error, busy, feedbackCh} = useFeedback();
    const [credentials, setCredentials] = useState({
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
    });
    const set = (name) => (value) => setCredentials((credentials) => ({...credentials, [name]: value}));
    const setPassword = useSetPassword(feedbackCh);

    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    const toast = useToast();
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    try {
                        await setPassword(credentials.currentPassword, credentials.newPassword, credentials.confirmNewPassword);
                        toast({
                            title: "Password changed.",
                            status: 'success',
                            isClosable: true,
                        });
                    } catch {
                        toast({
                            title: "An error occured - incorrect password?",
                            status: 'error',
                            isClosable: true,
                        });
                    }
                }
            }
        })().then(() => {}, () => {});
    }, [saveClicked]);

    return (
        <>
            <FixedTopBar back title="Change Password" border={false} save/>
            <WhiteMain className={className}>
                <FormContainer>

                    <Stack spacing={5} mb={"20px"}>

                        <FormControl>
                            <SwitchHeading>Current Password</SwitchHeading>
                            <Input type="password"
                                   maxLength="64"
                                   autoComplete="off"
                                   placeholder={'********'}
                                   required
                                   value={credentials.currentPassword}
                                   onChange={(e) => set('currentPassword')(e.currentTarget.value)} />
                            <FormHelperText>Required for security reasons.</FormHelperText>
                        </FormControl>

                    </Stack>

                    <Stack spacing={5} mb={"20px"}>

                        <FormControl>
                            <SwitchHeading>New Password</SwitchHeading>
                            <Input type="password"
                                   maxLength="64"
                                   autoComplete="off"
                                   placeholder={'********'}
                                   required
                                   value={credentials.newPassword}
                                   onChange={(e) => set('newPassword')(e.currentTarget.value)}
                            />
                            <FormHelperText>Password should be 8 characters or longer.</FormHelperText>
                        </FormControl>

                    </Stack>

                    <Stack spacing={5}>

                        <FormControl>
                            <SwitchHeading>Confirm New Password</SwitchHeading>
                            <Input type="password"
                                   maxLength="64"
                                   autoComplete="off"
                                   placeholder={'********'}
                                   required
                                   value={credentials.confirmNewPassword}
                                   onChange={(e) => set('confirmNewPassword')(e.currentTarget.value)}
                            />
                        </FormControl>

                    </Stack>

                </FormContainer>
            </WhiteMain>
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
  ${SwitchHeading} {
    font-weight: 600;
    font-size: 14px;
    padding: 6px 0;
  }
`;

export default PasswordSettings;
